import CryptoJS from "crypto-js";

export const getLocale = (defaultLocale = 'uz', key = 'lang') => {
  return localStorage.getItem(key) || defaultLocale
}

function addZeroPrefix(number) {
  return (number < 10 ? "0" : "") + number;
}

export function generateTimestamp() {
  const currentDate = new Date();

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();
  const hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const seconds = currentDate.getSeconds();

  const timestamp = `${year}-${addZeroPrefix(month)}-${addZeroPrefix(day)} ${addZeroPrefix(hours)}:${addZeroPrefix(minutes)}:${addZeroPrefix(seconds)}`;

  return timestamp;
}

export function queryToString(query) {
  let queryString = '?'
  Object.keys(query).forEach(item => {
    if (Array.isArray(query[item])) {
      query[item].forEach(childKey => {
        queryString += item + '=' + childKey + '&'
      })

    } else {
      if (query[item]) {
        queryString += item + '=' + query[item] + '&'
      }
    }
  })
  queryString = queryString.substring(0, queryString.length - 1)
  return queryString
}

export const debounce = (cb, delay) => {
  let timer
  return function (...args) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      cb.apply(this, args)
    }, delay)
  }
}

export const getQueryPage = (query = {}, defaultQueryPage = 0) => {
  if (query && query.page && !isNaN(query.page)) {
    defaultQueryPage = +query.page
  }
  return defaultQueryPage
}

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null
}


export const setCookie = (name, value, options = {}) => {
  const {expires, path, domain} = options
  let cookie = `${name}=${value};`

  if(expires) cookie += `expires=${expires};`
  if(path) cookie += `path=${path};`
  if(domain)  cookie+=`domain=${domain};`


  document.cookie = cookie
}

export function decryptString(key, encryptedText) {
  try {
    //@ts-ignore
    const iv = CryptoJS.lib.WordArray.create(16)
    const keyBytes = CryptoJS.SHA256(key)

    const decrypted = CryptoJS.AES.decrypt(
      // @ts-ignore
      {
        ciphertext: CryptoJS.enc.Base64.parse(encryptedText)
      },
      keyBytes,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    )

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
  } catch (ex) {
    // console.error(ex);
    return null
  }
}
